export const articles = [
  {
    id: "ent-night-gathering",
    title: "某顶流深夜聚餐被拍，同桌阵容不简单",
    summary:
      "昨晚一组聚餐路透流出，画面里出现了三位不同制作方的工作人员，网友顺着时间线扒出了下个月的项目排期。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20flat%20vector%20illustration%20of%20a%20single%20spotlight%20beam%20over%20an%20empty%20stage%2C%20warm%20coral%20and%20amber%20color%20palette%2C%20geometric%20shapes%2C%20clean%20cream%20background%2C%20no%20text%2C%20no%20people&width=800&height=500&seq=guayouhui-ent01&orientation=landscape",
    category: "entertainment",
    tags: ["路透", "项目排期", "聚餐"],
    author: "瓜田编辑部",
    publishTime: "今天 09:42",
    views: 128400,
    comments: 2861,
    hot: 9860,
    content: [
      "昨天晚上十点左右，有网友在社交平台晒出一组聚餐画面，位置在城东一家以包厢私密著称的餐厅。画面本身拍得并不清楚，但同桌出现的几位身影很快被眼尖的瓜友认了出来。",
      "值得注意的是，同桌的三位并不是同公司的艺人，而是分属不同制作团队的工作人员。<strong>这条线索比聚餐本身更耐人寻味</strong>，因为多团队同框通常意味着某个跨平台项目开始进入筹备阶段。",
      "有熟悉行业节奏的网友补充，按照通常的流程，聚餐之后大约两到三周会进入正式签约与档期协调。也就是说，如果传闻属实，下个月中旬前后应该会有更明确的消息。",
      "目前当事双方均未回应，相关话题已经冲上热榜前列。瓜友会网会持续跟进，一旦有官方口径会第一时间更新在时间线里，建议收藏本篇以便回看。",
    ],
  },
  {
    id: "ent-script-rumor",
    title: "新剧剧本围读照曝光，番位讨论再次升温",
    summary:
      "一张围读现场的照片让原本平静的选角话题重新热闹起来，番位与戏份比例成了讨论焦点。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20flat%20vector%20illustration%20of%20a%20film%20clapperboard%20and%20folded%20script%20pages%20on%20a%20table%2C%20warm%20terracotta%20and%20cream%20palette%2C%20geometric%20shapes%2C%20no%20text%2C%20no%20people&width=800&height=500&seq=guayouhui-ent02&orientation=landscape",
    category: "entertainment",
    tags: ["新剧", "围读", "番位"],
    author: "追剧组小满",
    publishTime: "今天 08:15",
    views: 96200,
    comments: 3410,
    hot: 8120,
    content: [
      "一张剧本围读照在今天早上被放出，照片里长桌两侧坐满了主创，桌上摆着贴了彩色标签的剧本，气氛看起来相当正式。",
      "照片流出后，讨论很快从'什么时候开机'转向了'谁排在第一'。有网友根据座位顺序推测番位，也有人认为座位与番位并无必然联系。",
      "事实上，业内对番位的判断标准一直在变化。<strong>戏份比例、角色重要性与市场号召力往往同时被考虑</strong>，单纯看一张照片容易得出片面结论。",
      "目前片方尚未公布完整阵容，瓜友会网建议先看作品再下判断。我们会在官方物料发布后整理一版清晰的阵容说明。",
    ],
  },
  {
    id: "inf-live-mishap",
    title: "头部主播直播现场翻车，选品流程被网友复盘",
    summary:
      "一场常规带货直播中出现沟通失误，弹幕迅速跑偏，网友把注意力转向了选品与审核环节。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20flat%20vector%20illustration%20of%20a%20smartphone%20on%20a%20ring%20light%20setup%20with%20floating%20geometric%20live%20symbols%2C%20warm%20coral%20and%20amber%20palette%2C%20cream%20background%2C%20minimal%20vector%20style%2C%20no%20text&width=800&height=500&seq=guayouhui-inf01&orientation=landscape",
    category: "influencer",
    tags: ["直播", "选品", "带货"],
    author: "直播间观察员",
    publishTime: "今天 10:20",
    views: 143700,
    comments: 4126,
    hot: 10240,
    content: [
      "昨晚的带货直播原本节奏平稳，中途在介绍一款产品时出现了口播与页面信息不一致的情况，主播停顿了几秒后临时跳过，弹幕瞬间刷屏。",
      "事后有网友翻出直播回放，逐帧比对后发现，问题大概率出在脚本更新与页面同步之间的时间差，并非有意为之。<strong>但这类失误恰恰暴露了选品复核环节的短板。</strong>",
      "几位做供应链的网友在评论区科普了标准流程：通常需要经过资质审核、样品实测、法务复核三道关卡，任何一环压缩时间都可能出问题。",
      "团队目前发布了简短说明，表示会优化内部流程。瓜友会网会持续关注后续是否公布更完整的整改措施。",
    ],
  },
  {
    id: "inf-account-swing",
    title: "账号数据一夜回暖，涨粉曲线背后的运营逻辑",
    summary:
      "某账号在沉寂两周后数据突然回升，粉丝增长曲线出现明显拐点，运营策略引发同行讨论。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20flat%20vector%20illustration%20of%20a%20microphone%20surrounded%20by%20floating%20chat%20bubbles%20and%20upward%20arrow%20shapes%2C%20warm%20amber%20and%20soft%20green%20palette%2C%20cream%20background%2C%20minimal%20vector%20style%2C%20no%20text&width=800&height=500&seq=guayouhui-inf02&orientation=landscape",
    category: "influencer",
    tags: ["涨粉", "运营", "数据分析"],
    author: "新媒体手记",
    publishTime: "昨天 21:30",
    views: 68400,
    comments: 1522,
    hot: 6140,
    content: [
      "有网友做了一份简单的数据图，把这个账号近三十天的涨粉曲线画了出来。明显能看到，在沉寂了两周之后，曲线在最近三天突然抬头。",
      "对比发布时间可以发现，转折点出现在账号调整内容方向之后：从日常碎碎念转向了更垂直的选题。",
      "有运营从业者分析，<strong>重新聚焦垂类往往能触发平台的二次推荐</strong>，但能否稳住还要看后续内容的持续供给能力。",
      "目前账号本人没有回应这份数据解读。值得一提的是，仅凭第三方数据平台推算的曲线存在误差，围观时不妨留一点余地。",
    ],
  },
  {
    id: "emo-cp-signal",
    title: "恋爱综艺 CP 疑似营业，细节党列出三处对应时间",
    summary:
      "节目结束后双方互动频率骤增，网友把同款物件、背景墙面和发布时间串成了一条时间线。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20flat%20vector%20illustration%20of%20two%20overlapping%20speech%20bubbles%20forming%20a%20soft%20heart%20shape%2C%20warm%20coral%20and%20blush%20palette%2C%20cream%20background%2C%20minimal%20vector%20style%2C%20no%20text&width=800&height=500&seq=guayouhui-emo01&orientation=landscape",
    category: "emotion",
    tags: ["恋爱综艺", "CP", "时间线"],
    author: "情感瓜研究所",
    publishTime: "今天 07:50",
    views: 158200,
    comments: 5320,
    hot: 11380,
    content: [
      "节目收官已经过去一个月，两位嘉宾的互动却明显频繁了起来。先是同款挂件出现在各自的照片角落，接着是背景墙面高度相似的室内照。",
      "最能说明问题的是发布时间：两张照片的间隔不到十分钟，且拍摄角度像是同一天的不同时段。细节党据此认为，两人近期大概率身处同一地点。",
      "不过也有理性的瓜友提醒，<strong>同款物件在综艺嘉宾之间并不罕见</strong>，节目组统一准备的纪念品也可能造成巧合。",
      "双方团队目前未做任何表态。感情类话题最忌讳过度解读，瓜友会网会保持关注，但不建议上升到对个人生活的打扰。",
    ],
  },
  {
    id: "emo-breakup-confirm",
    title: "公开恋情一年后官宣分手，双方回应措辞耐人寻味",
    summary:
      "两份声明在同一分钟发布，文字高度对称，网友注意到彼此都刻意回避了同一个关键词。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20flat%20vector%20illustration%20of%20a%20folded%20paper%20heart%20on%20a%20neutral%20backdrop%20with%20geometric%20shapes%2C%20warm%20sand%20and%20muted%20terracotta%20palette%2C%20cream%20background%2C%20minimal%20vector%20style%2C%20no%20text&width=800&height=500&seq=guayouhui-emo02&orientation=landscape",
    category: "emotion",
    tags: ["分手", "声明", "回应"],
    author: "情感瓜研究所",
    publishTime: "昨天 19:05",
    views: 211600,
    comments: 7840,
    hot: 13260,
    content: [
      "昨天傍晚，两位当事人的工作室在同一分钟发布了内容高度对称的声明，宣布结束恋情，并表示未来会以朋友身份相处。",
      "细心的网友发现，两份声明都用了'和平'这个表述，却都刻意没有提到分手的具体时间。<strong>这种刻意的留白反而成了讨论的焦点。</strong>",
      "有法律从业者在评论区解释，公众人物在声明中回避具体时间点，通常是为了减少后续被反复追问的空间，属于比较常见的处理方式。",
      "截至目前，双方没有再发布新的内容。无论原因如何，感情变化都属个人隐私，围观之余也请给当事人留出空间。",
    ],
  },
  {
    id: "work-org-shift",
    title: "某大厂组织架构调整传闻，内部员工现身说法",
    summary:
      "一则关于业务线合并的传闻在职场社区发酵，多位自称员工的人给出了不尽相同的描述。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20flat%20vector%20illustration%20of%20a%20laptop%20on%20a%20desk%20with%20a%20coffee%20cup%20and%20sticky%20notes%2C%20warm%20amber%20and%20cream%20palette%2C%20geometric%20shapes%2C%20minimal%20vector%20style%2C%20no%20text&width=800&height=500&seq=guayouhui-work01&orientation=landscape",
    category: "workplace",
    tags: ["组织调整", "业务线", "职场"],
    author: "职场显微镜",
    publishTime: "今天 11:10",
    views: 87300,
    comments: 2940,
    hot: 7260,
    content: [
      "今天上午，一则关于某业务线可能合并的帖子在职场社区被顶上热榜。发帖人称消息来自内部沟通会，但未提供更多细节。",
      "随后有几位自称员工的网友在评论区补充，说法并不一致：有人认为只是汇报线调整，也有人表示确实涉及团队重组。<strong>信息在传播过程中出现了明显的放大。</strong>",
      "一位做人力资源的网友分享了一个判断方法：如果只是汇报关系变化，通常不会影响项目排期；一旦涉及项目归并，则要看后续的招聘计划是否冻结。",
      "公司方面暂未发布正式公告。职场类传闻容易引发焦虑，建议以官方口径为准，瓜友会网会持续跟进核实。",
    ],
  },
  {
    id: "work-hiring-freeze",
    title: "招聘节奏放缓实感：从业者聊了聊最近的面试体验",
    summary:
      "几位求职者分享了近期的面试流程变化，从轮次压缩到薪资沟通方式，细节里藏着行业温度。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20flat%20vector%20illustration%20of%20minimal%20office%20elevator%20doors%20with%20geometric%20accent%20shapes%2C%20warm%20terracotta%20and%20sand%20palette%2C%20cream%20background%2C%20minimal%20vector%20style%2C%20no%20text&width=800&height=500&seq=guayouhui-work02&orientation=landscape",
    category: "workplace",
    tags: ["求职", "面试", "行业观察"],
    author: "职场显微镜",
    publishTime: "昨天 16:40",
    views: 54200,
    comments: 1180,
    hot: 4980,
    content: [
      "最近有网友在社区发起了一个小调查，邀请求职者聊聊近期的面试体验，一天之内收到了上百条回复。",
      "汇总来看，几个变化比较一致：面试轮次从常见的四轮压缩到了三轮，终面与薪资沟通被合并到同一场，决策周期也明显缩短。",
      "有资深招聘经理分析，<strong>流程压缩通常意味着岗位需求更明确</strong>，对匹配度高的候选人反而更友好，但也意味着试错空间变小。",
      "需要提醒的是，个体经验差异很大，样本量有限，不足以代表整体行情。本文仅作参考，不构成任何求职建议。",
    ],
  },
  {
    id: "tech-flagship-debut",
    title: "新旗舰发布后口碑两极，参数之外的真实体验成了关键",
    summary:
      "发布会上的亮点参数很吸睛，但首批用户的反馈集中在日常使用场景，讨论重心迅速转移。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20flat%20vector%20illustration%20of%20an%20abstract%20circuit%20board%20pattern%20with%20geometric%20nodes%2C%20warm%20amber%20and%20soft%20green%20palette%2C%20cream%20background%2C%20minimal%20vector%20style%2C%20no%20text&width=800&height=500&seq=guayouhui-tech01&orientation=landscape",
    category: "tech",
    tags: ["新品", "口碑", "体验"],
    author: "数码瓜田",
    publishTime: "今天 09:05",
    views: 112800,
    comments: 3260,
    hot: 8940,
    content: [
      "新旗舰发布已经过去一周，发布会上的几个参数曾引发大量讨论。但随着首批用户上手，舆论重心很快从参数表转移到了日常体验。",
      "目前反馈比较集中的是两点：一是长时间使用后的发热控制，二是系统更新节奏。两者都属于发布会上很难被量化的部分。",
      "有长期做评测的博主指出，<strong>参数领先与体验领先之间往往存在时间差</strong>，首批固件通常还需要两到三次更新才会趋于稳定。",
      "如果你还在观望，不妨等两周后的口碑沉淀。瓜友会网会整理一版用户反馈汇总，届时再一起看会更清晰。",
    ],
  },
  {
    id: "tech-ai-buzz",
    title: "AI 功能成新卖点，用户却更在意它到底省了多少事",
    summary:
      "越来越多产品把 AI 写进海报，但真正留住用户的，往往是那些不起眼的小场景。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20flat%20vector%20illustration%20of%20a%20glowing%20abstract%20chip%20surrounded%20by%20floating%20data%20shapes%2C%20warm%20coral%20and%20amber%20palette%2C%20cream%20background%2C%20minimal%20vector%20style%2C%20no%20text&width=800&height=500&seq=guayouhui-tech02&orientation=landscape",
    category: "tech",
    tags: ["AI", "产品", "用户反馈"],
    author: "数码瓜田",
    publishTime: "昨天 20:15",
    views: 74800,
    comments: 1690,
    hot: 5820,
    content: [
      "最近一轮新品发布会里，AI 几乎成了标配词。从文档摘要到图片生成，各家都在强调能力边界被再次拓宽。",
      "但翻看用户讨论会发现，真正被高频使用的往往是那些看起来不起眼的功能：会议记录自动整理、长文一键压缩、跨应用信息检索。",
      "一位产品经理的观点颇具代表性：<strong>用户不关心模型参数，只关心自己少点了几次鼠标。</strong> 这句话在评论区被反复引用。",
      "AI 功能的热度还会持续，但能否沉淀为习惯，取决于它是否稳定、是否真的省事。这一点，时间会给出答案。",
    ],
  },
  {
    id: "var-editing-storm",
    title: "综艺剪辑引争议，正片与花絮顺序差异被放大对比",
    summary:
      "同一段互动在正片与花絮中的呈现顺序不同，网友做了一版对照图，讨论迅速升温。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20flat%20vector%20illustration%20of%20a%20television%20studio%20lighting%20rig%20with%20geometric%20spotlights%2C%20warm%20amber%20and%20coral%20palette%2C%20cream%20background%2C%20minimal%20vector%20style%2C%20no%20text&width=800&height=500&seq=guayouhui-var01&orientation=landscape",
    category: "variety",
    tags: ["综艺", "剪辑", "花絮"],
    author: "追综小分队",
    publishTime: "今天 12:30",
    views: 92700,
    comments: 3040,
    hot: 7680,
    content: [
      "最新一期节目播出后，有网友把正片与花絮中同一段互动的镜头做了对照，发现呈现顺序存在明显差异，相关话题随即升温。",
      "从对照图来看，正片把两个镜头剪得更为紧凑，而花絮里保留了中间的过渡画面。<strong>顺序调整往往会改变观众对情绪的解读。</strong>",
      "有从事后期工作的网友解释，综艺剪辑需要在有限时长内完成叙事，调整顺序属于常规操作，但确实容易造成理解偏差。",
      "节目组目前未就剪辑方式作出回应。瓜友会网建议，想要完整判断的话，正片与花絮一起看会更接近真实情况。",
    ],
  },
  {
    id: "var-stage-save",
    title: "舞台出现小插曲，嘉宾临场救场的三秒被反复回看",
    summary:
      "一个几乎察觉不到的临场处理，被镜头完整记录下来，专业度赢得不少好评。",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20flat%20vector%20illustration%20of%20a%20stage%20curtain%20with%20a%20single%20spotlight%20beam%2C%20warm%20coral%20and%20amber%20palette%2C%20cream%20background%2C%20minimal%20vector%20style%2C%20no%20text&width=800&height=500&seq=guayouhui-var02&orientation=landscape",
    category: "variety",
    tags: ["舞台", "救场", "幕后"],
    author: "追综小分队",
    publishTime: "昨天 22:10",
    views: 61300,
    comments: 1420,
    hot: 5240,
    content: [
      "昨晚的舞台表演整体顺畅，但中途出现了一个小插曲：耳返似乎短暂失灵，嘉宾有一瞬间的迟疑。",
      "镜头完整记录下了接下来的三秒——嘉宾顺势把迟疑改成了一段即兴互动，观众几乎没察觉，节目反而因此多了一个记忆点。",
      "事后有现场观众在评论区确认，当时确实听到了轻微的杂音。<strong>临场处理能力往往比排练效果更能看出功底。</strong>",
      "这段画面当晚就被剪成对比视频广泛传播，评论区以正面评价为主。瓜友会网会持续关注节目后续的舞台表现。",
    ],
  },
];